import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {FavoriteService} from '../../Services/favorite.service';

@Component({
    selector: 'app-wish-list',
    templateUrl: './wish-list.component.html',
    styleUrls: ['./wish-list.component.scss'],
    standalone: false
})
export class WishListComponent implements OnInit {


  favoriteProductCount = 0;

  constructor(private favoriteService: FavoriteService,
              private router: Router) { }

  ngOnInit(): void {
    // logged in or not: FavoriteService holds the account's or the localStorage favorites
    this.favoriteService.favoritesCount$.subscribe((count) => {
      this.favoriteProductCount = count;
    });
  }

  goToCartCheckout() {
    this.router.navigate(['cart/favorites']);
  }
}
